export default __webpack_public_path__ + "static/media/one.4a673d03.jpeg";